import React from 'react';
import {COLORS} from "../../consts";
import classNames from "classnames";
import styles from "./styles/dropdown.module.scss";

class DropdownArrowUpProps {
  className: String;
  color: COLORS;
}

export const DropdownArrowUp = (props: DropdownArrowUpProps) => {
  const className = classNames(props.className || styles.arrow_up);
  const style = {borderBottom: '5px solid ' + (props.color)}

  return <div className={className} style={style}/>
}
